import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme) => ({
  label: {
   color: theme.palette.grey[300]
  },
  link: {
    color: theme.palette.primary.contrastText
  }
}))
